// extracted by mini-css-extract-plugin
export default {"logo":"LogoLink-module--logo--bceb4"};